import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setOpenItem,
  markItemUndone,
  deleteItem,
} from "shared/itemLists/redux/itemListsSlice";

import BreakStroke from "../BreakStroke";
import SwipeOptions from "./SwipeOptions/SwipeOptions";
import { CSSTransition } from "react-transition-group";
import { sortableHandle } from "react-sortable-hoc";
import Loader from "react-loader-spinner";
import colors from "../../../styles/_colors.scss";

import ConditionalWrapper from "globalComponents/ConditionalWrapper";

import ChecklistIconButton from "./ChecklistIconButton.js";

const SortableHandle = sortableHandle((props) => (
  <div className="item-inner-wrapper item-txtstyl" {...props} />
));

class ItemContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseIsDown: false,
      mouseDownTimeStamp: 0,
      isItemSwipedRight: false,
      isItemSwipedLeft: !!props.details.isItemSwipedLeft,
      isItemMounted: true,
      isContainerIn: true,
      isItemMarkedUndone: false,
    };
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.setIsItemSwipedLeft = this.setIsItemSwipedLeft.bind(this);
    this.setIsItemMarkedUndone = this.setIsItemMarkedUndone.bind(this);
    this.handleItemExitedLeft = this.handleItemExitedLeft.bind(this);
    this.handleTrashClick = this.handleTrashClick.bind(this);
  }
  shouldComponentUpdate(prevProps, prevState) {
    return (
      this.props.details !== prevProps.details ||
      this.props.hasBreak !== prevProps.hasBreak ||
      this.state.mouseIsDown !== prevState.mouseIsDown ||
      this.state.isItemSwipedRight !== prevState.isItemSwipedRight ||
      this.state.isItemSwipedLeft !== prevState.isItemSwipedLeft ||
      this.state.isItemMarkedUndone !== prevState.isItemMarkedUndone ||
      this.props.details.isJustMarkedUndone !==
        prevProps.details.isJustMarkedUndone ||
      this.state.isItemMounted !== prevState.isItemMounted ||
      this.state.isContainerIn !== prevState.isContainerIn ||
      (this.props.details.type === "new_task" &&
        this.props.newTask !== prevProps.newTask)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.details.isJustMarkedUndone !==
      prevProps.details.isJustMarkedUndone
    ) {
      if (this.props.details.isJustMarkedUndone) {
        this.setIsItemMarkedUndone(true);
      }
    }
    if (this.props.details.isJustCompleted) {
      this.setState({ isItemSwipedRight: true });
    }
    if (this.state.isItemMarkedUndone !== prevState.isItemMarkedUndone) {
      if (this.state.isItemMarkedUndone) {
        setTimeout(() => {
          this.setState({ isItemSwipedLeft: true });
        }, 200);
      }
    }
  }

  setIsItemSwipedLeft(value) {
    this.setState({ isItemSwipedLeft: value });
  }

  setIsItemMarkedUndone(value) {
    this.setState({ isItemMarkedUndone: value });
  }

  handleItemClick() {
    if (!this.props.details.blank) {
      this.props.setOpenItem((currOI) => {
        return {
          ...currOI,
          isOpen: true,
          index: this.props.inListIndex,
          details: this.props.details,
          setIsItemSwipedLeft: this.setIsItemSwipedLeft,
          isDue: this.props.isDue,
          isDone: this.props.listType === "Done",
        };
      });
    }
  }

  handleMouseDown(e) {
    this.setState({
      mouseIsDown: true,
      mouseDownTimeStamp: e.timeStamp,
    });
  }

  handleMouseMove(e) {
    if (this.state.mouseIsDown && this.isSwipeable()) {
      if (e.movementX > 5) {
        this.setState({
          mouseIsDown: false,
          isItemSwipedRight: true,
        });
      } else if (e.movementX < -5) {
        this.setState({
          mouseIsDown: false,
        });
        if (this.state.isItemSwipedRight) {
          this.setState({
            isItemSwipedRight: false,
          });
        } else {
          this.setState({
            isItemSwipedLeft: true,
          });
        }
      }
    }
  }

  handleMouseLeave(e) {
    this.setState({ mouseIsDown: false });
  }

  handleMouseUp(e) {
    const duration = e.timeStamp - this.state.mouseDownTimeStamp;
    if (
      this.state.mouseIsDown &&
      duration < 200 &&
      this.props.details.type !== "day_name"
    ) {
      this.handleItemClick();
    }
    this.setState({ mouseIsDown: false });
  }

  handleItemExitedLeft(e) {
    if (this.state.isItemMarkedUndone) {
      this.props.markItemUndone({ id: this.props.details.id });
    } else {
      this.handleItemClick();
    }
  }

  hasOptions() {
    return (
      this.state.isItemSwipedRight ||
      (this.props.listType !== "Plan" &&
        this.props.details.type !== "day_name" &&
        this.props.details.type !== "new_task" &&
        this.props.details.type !== "calendar_note" &&
        this.props.details.type !== "continuing_calendar_note" &&
        (!this.props.isToday || !this.props.details.time))
    );
  }

  handleTrashClick() {
    if (window.confirm("Are you sure you want to delete?")) {
      this.props.deleteItem({
        isDueItem: this.props.isDue,
        index: this.props.inListIndex,
        isDone: this.props.listType === "Done",
        itemType: this.props.details.type,
        id: this.props.details.id,
        method: { type: "swipe" },
      });
    }
  }

  isSwipeable() {
    return this.props.details.type !== "day_name";
  }

  contents() {
    const { details, relevantItem } = this.props;
    console.log("relevantItem in contents: ", relevantItem);
    const { type, has_checklist } = details;
    const swipeable =
      this.props.details.type !== "day_name" &&
      this.props.details.type !== "continuing_calendar_note";
    const hasOptions = this.hasOptions();
    return (
      <>
        {this.state.isContainerIn && (
          <div
            className={
              "item-container-outer-wrapper " +
              (swipeable ? "swipeable " : "") +
              type
            }
          >
            {this.state.isItemMounted && (
              <>
                {this.props.hasBreak && <BreakStroke />}
                <ConditionalWrapper
                  condition={this.isSwipeable()}
                  wrapper={(children) => (
                    <CSSTransition
                      in={!this.state.isItemSwipedLeft}
                      timeout={300}
                      onExited={this.handleItemExitedLeft}
                      classNames="left-swiping-div"
                    >
                      <CSSTransition
                        in={!this.state.isItemSwipedRight}
                        timeout={300}
                        classNames="right-swiping-div"
                      >
                        {children}
                      </CSSTransition>
                    </CSSTransition>
                  )}
                  children={
                    <div
                      className={
                        "Item-container noselect" +
                        " " +
                        this.props.details.type +
                        " " +
                        " " +
                        this.props.listType +
                        " " +
                        (this.props.hasBreak ? " has-break" : "") +
                        (this.state.isItemSwipedRight
                          ? " right-swiping-div-not-in"
                          : "") +
                        (hasOptions ? " checkable" : "")
                      }
                      onMouseDown={this.handleMouseDown}
                      onMouseLeave={
                        this.state.mouseIsDown
                          ? this.handleMouseLeave
                          : undefined
                      }
                      onMouseMove={
                        this.state.mouseIsDown
                          ? this.handleMouseMove
                          : undefined
                      }
                      onMouseUp={
                        this.state.mouseIsDown ? this.handleMouseUp : undefined
                      }
                    >
                      <SortableHandle>
                        {this.props.relevantItem()}
                        {this.props.details.isPending && (
                          <div className="loader-container">
                            <Loader
                              type="Oval"
                              color={colors.light_blue}
                              height={25}
                              width={25}
                            />
                          </div>
                        )}
                      </SortableHandle>
                      {(type === "appointment" || type === "task") &&
                        has_checklist && (
                          <ChecklistIconButton
                            itemId={details.id}
                            setOpenChecklist={this.props.setOpenChecklist}
                          />
                        )}
                    </div>
                  }
                />
              </>
            )}
            {hasOptions && (
              <SwipeOptions
                numOptions={this.state.isItemSwipedRight ? 2 : 1}
                itemId={this.props.details.id}
                setIsItemMarkedUndone={this.setIsItemMarkedUndone}
                isItemMarkedUndone={this.state.isItemMarkedUndone}
                setIsContainerIn={(value) =>
                  this.setState({ isContainerIn: value })
                }
                setIsItemMounted={(value) =>
                  this.setState({ isItemMounted: value })
                }
                itemType={type}
                handleTrashClick={this.handleTrashClick}
                listType={this.props.listType}
                isDue={this.props.isDue}
                isJustCompleted={this.props.details.isJustCompleted}
              />
            )}
          </div>
        )}
      </>
    );
  }
  render() {
    return this.contents();
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setOpenItem, markItemUndone, deleteItem },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(ItemContainer);
